import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Crown, MapPin, Clock, Globe, Star, Users } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: <Crown size={32} data-id="element-191" />,
    title: '高端伴游 Premium Escort',
    desc: '精选优质伴游，提供专业陪伴服务，适合商务宴请、社交活动及私人约会'
  }, {
    icon: <MapPin size={32} data-id="element-192" />,
    title: '酒店服务 Hotel Service',
    desc: '支持新加坡各大酒店上门服务，安全便捷，全程保密'
  }, {
    icon: <Clock size={32} data-id="element-193" />,
    title: '短期伴侣 Short-term Companion',
    desc: '灵活的短时陪伴方案，满足您不同场合的需求'
  }, {
    icon: <Globe size={32} data-id="element-194" />,
    title: '旅行伴游 Travel Companion',
    desc: '为来新加坡旅游的客户提供贴心的全程陪伴服务'
  }, {
    icon: <Star size={32} data-id="element-195" />,
    title: 'VIP定制 VIP Custom',
    desc: '专属VIP定制服务，根据您的个人喜好量身打造完美体验'
  }, {
    icon: <Users size={32} data-id="element-196" />,
    title: '多国佳丽 International',
    desc: '汇聚亚洲各国佳丽，中国、越南、泰国、日韩等多元选择'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-24 px-4 relative z-10 bg-[#0d0d14]" data-id="element-197">
      <div className="max-w-6xl mx-auto" data-id="element-198">
        <motion.div className="text-center mb-16" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-199">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-5xl font-bold mb-4" data-id="element-200">
            服务<span className="text-pink-primary neon-glow" data-id="element-201">类别</span>
          </motion.h2>
          <motion.div variants={itemVariants} className="w-24 h-1 bg-pink-primary mx-auto rounded-full mb-4" data-id="element-202"></motion.div>
          <motion.p variants={itemVariants} className="text-gray-400 text-lg" data-id="element-203">
            满足您在新加坡的各种陪伴需求
          </motion.p>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={containerVariants} data-id="element-204">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="bg-dark-card p-8 rounded-2xl neon-border group relative overflow-hidden" data-id="element-205">
              <div className="absolute top-0 right-0 w-32 h-32 bg-pink-primary/10 rounded-bl-full -mr-10 -mt-10 transition-transform group-hover:scale-110" data-id="element-206"></div>
              <div className="text-pink-primary mb-6 relative z-10 drop-shadow-[0_0_8px_rgba(233,30,140,0.5)]" data-id="element-207">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3 relative z-10" data-id="element-208">
                {service.title}
              </h3>
              <p className="text-gray-400 leading-relaxed relative z-10" data-id="element-209">
                {service.desc}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}